import { ROUTE_UI_SECTION_NAME } from '../../../constants/route'
import { useSectionPermissions } from '../../../hooks'
import { UserProfileTabs } from '../../User'
import {
  isUserProfilePageAddNewActionPermitted,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION,
  useUserProfilePageCreateEmailAction,
} from '../UserProfilePageHeaderFooter'

import { getUserProfilePageTabList } from './UserProfilePageTabs.utils'

function UserProfilePageTabs({ userData }) {
  const { canCreate: canCreateEmails } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.mails,
  })

  const { handleClickCreateEmail } = useUserProfilePageCreateEmailAction()

  const canSendEmail =
    userData &&
    isUserProfilePageAddNewActionPermitted({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email,
      canCreateEmails,
      userData,
    })

  return (
    <UserProfileTabs
      tabs={getUserProfilePageTabList({
        userData,
        onClickAddEmail: canSendEmail ? handleClickCreateEmail : null,
      })}
      userData={userData}
    />
  )
}

export default UserProfilePageTabs
